<section class="bk-panel sb-preview" aria-labelledby="seg-preview-title">
  <p class="bk-eyebrow" id="seg-preview-title">Matches</p>
  <p class="bk-sr-only" role="status">{{ announcement }}</p>

  @switch (state) {
    @case ('empty') {
      <p class="sb-preview__note">Add a condition to see how many contacts it picks.</p>
    }
    @case ('error') {
      <p class="sb-preview__error">The estimate did not load. It retries when you change a condition.</p>
    }
    @default {
      <div class="sb-preview__figure">
        @if (count === null) {
          <span class="bk-skel sb-preview__skel" aria-hidden="true"></span>
          <span class="bk-sr-only">Counting contacts</span>
        } @else {
          <span class="sb-preview__value" [class.is-stale]="state === 'loading'">About {{ formatCount(count) }}</span>
          <span class="sb-preview__unit">{{ count === 1 ? 'contact' : 'contacts' }}</span>
        }
      </div>
    }
  }

  @if (sentence) {
    <p class="sb-preview__sentence">{{ sentence }}</p>
  }
  @if (skippedNote) {
    <p class="sb-preview__note">{{ skippedNote }}</p>
  }
  @if (state !== 'empty') {
    <p class="sb-preview__note">The exact number is worked out when the segment is saved, and it changes as your contacts do.</p>
  }
</section>
